import React from "react";

import useStyles from "../style";
import { renderError } from "../../../utils/validate";

function ClaimLinkInput(props: any) {
  const classes: any = useStyles();
  const {
    register,
    setValue,
    errors,
    isEditDisabled,
    poolDetail
  } = props;

  const handleTokenGetInfo = (e: any) => {
    setValue(e.target.value);
  };
  return (
    <>
        <div>
          <label className={classes.formControlLabel}>Claim Link</label>
          <div className={classes.formControlInputLoading}>
            <input
              type="text"
              name="external_claim_link"
              ref={register({
              })}
              maxLength={255}
              defaultValue={poolDetail?.external_claim_link}
              onChange={handleTokenGetInfo}
              className={classes.formControlInput}
              style={{
                backgroundColor: isEditDisabled ? "#F0F0F0" : "transparent",
              }}
            />
          </div>
          <p className={`${classes.formErrorMessage}`}>
            {renderError(errors, "external_claim_link")}
          </p>
        </div>
    </>
  );
}

export default ClaimLinkInput;
